import React, {Component} from 'react';
// import NavBar from '../navbar/navbar'
import NavBarTest from '../navbar/NavBarTest'
import AppFooter from '../footer/footer'

// import {Card} from 'antd'
class Privacy extends Component {

    render() {


        return (
            <React.Fragment>
                {/* <NavBar/> */}
                <NavBarTest/>

                <div className="policies">

                    <section id="main">
                        <div className="container">
                            <article>
                                <h2 className="page-title">
                                    Privacy Policy
                                </h2>
                                <h5>
                                    Last updated: May 12, 2020
                                </h5>
                                <p>This Privacy Policy describes Our policies and procedures on the collection,
                                    use and disclosure of Your information.</p>
                                <p>We use Your Personal data to provide and improve the Service. By using the Service,
                                    You agree to the collection and use
                                    of information in accordance with this Privacy Policy.</p>

                                <h1>Interpretation and Definitions</h1>

                                <h3 className="the-zimble-policies-header">Interpretation</h3><p>The words of which the
                                initial letter is capitalized have meanings defined under
                                the following conditions.
                                The following definitions shall have the same meaning regardless of whether they
                                appear in singular or in plural.
                            </p>
                                {/*<h3>Definitions</h3>*/}
                                <h3 className="the-zimble-policies-header">
                                    Definition – for the purposes of this Privacy Policy:
                                </h3>

                                <p>
                                    <li><b>You</b> mean the individual accessing or using the Service, or the company,
                                        or other legal entity on behalf of which such
                                        individual is accessing or using the Service, as applicable.
                                    </li>
                                </p>
                                <p>
                                    <li><b>Company </b>(referred to as either "the Company", "We", "Us" or "Our" in this
                                        Agreement) refers to Zimble.
                                    </li>
                                </p>


                                <p>
                                    <li><b>Affiliate</b> means an entity that controls, is controlled by or is under
                                        common control with a party, where "control" means
                                        ownership of 50% or more of the shares, equity interest or other securities
                                        entitled to vote for election of directors
                                        or other managing authority.
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b>Account</b> means a unique account created for You to access our Service
                                        or parts of our Service.
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b>Website</b> refers to Zimble, accessible from <a
                                        href="https://thezimble.com">thezimble.com</a>
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b>Services</b> refers to the Website.
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b>Country</b> refers to: Florida, United States.
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b>Service Provider</b> means any natural or legal person who processes the data
                                        on behalf of the Company. It refers to
                                        third-party companies or individuals employed by the Company to facilitate the
                                        Service, to provide the Service on behalf
                                        of the Company, to perform services related to the Service or to assist the
                                        Company in analyzing how the Service is
                                        used.
                                    </li>
                                </p>

                                <p>
                                    <li>
                                        <b>Personal Data </b>is any information that relates to an identified or
                                        identifiable individual.
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b>Cookies</b> are small files that are placed on Your computer, mobile device
                                        or any other device by a website, containing the
                                        details of Your browsing history on that website among its many uses.
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b>Device </b>means any device that can access the Service such as a computer, a
                                        cell phone or a digital tablet.
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b>Usage Data</b> refers to data collected automatically, either generated by
                                        the use of the Service or from the Service
                                        infrastructure itself (for example, the duration of a page visit).
                                    </li>
                                </p>
                                <h1>

                                    Collecting and Using Your Personal Data

                                </h1>
                                <h2>Types of Data Collected:</h2>
                                <h4>
                                    Personal Data
                                </h4>
                                <p>
                                    While using Our Service, We may ask You to provide Us with certain personally
                                    identifiable information that can be used
                                    to contact or identify You. Personally identifiable information may
                                    include, but is not limited to:
                                </p>

                                <li>
                                    First name and last name
                                </li>
                                <li>
                                    Registration information, username, password,
                                    and email
                                </li>
                                <li>
                                    Usage Data and User-generated content, including comments, written posts, videos,
                                    and virtual item videos that you choose
                                    to upload or broadcast on the Platform (“User Content”)
                                </li>

                                <h3 className="the-zimble-policies-header">
                                    Usage Data and User Generated Content:
                                </h3>

                                <p>
                                    Usage Data is collected automatically when using the Service.
                                </p>
                                <p>
                                    Usage Data may include information such as Your Device's Internet Protocol address
                                    (e.g. IP address), browser type,
                                    browser version, the pages of our Service that You visit, the time and date of Your
                                    visit, the time spent on those
                                    pages, unique device identifiers and other diagnostic data.
                                </p>

                                <p>
                                    When You access the Service by or through a mobile device, We may collect certain
                                    information automatically, including,
                                    but not limited to, the type of mobile device You use, Your mobile device unique ID,
                                    the IP address of Your mobile
                                    device, Your mobile operating system, the type of mobile Internet browser You use,
                                    unique device identifiers and other
                                    diagnostic data.
                                </p>

                                <p>
                                    We collect information about your location, including location information based on
                                    your SIM card and/or IP address.
                                    With your permission, we may also collect Global Positioning System (GPS) data.
                                </p>

                                <p>
                                    We may also collect information that Your browser sends whenever You visit our
                                    Service or when You access the Service by
                                    or through a mobile device.
                                </p>

                                <p>
                                    We may collect and process, which includes scanning and analyzing, information you
                                    provide in the context of composing,
                                    sending, or receiving messages through the Platform’s messaging functionality. That
                                    information includes the content of
                                    the message and information about when the message has been sent, received and/or
                                    read, as well as the participants of
                                    the communication. Please be aware that messages sent to other users of the Platform
                                    will be accessible by those users
                                    and that we are not responsible for the manner in which those users use or disclose
                                    messages.
                                </p>

                                <p>
                                    When you upload User Content, you automatically upload certain metadata that is
                                    connected to the User Content. Metadata
                                    describes other data and provides information about your User Content that will not
                                    always be evident to the viewer. In
                                    connection with your User Content the metadata can describe how, when, and by whom
                                    the piece of User Content was
                                    collected and how that content is formatted. It also includes information, such as
                                    your account name, that enables other
                                    users to trace back the User Content to your user account. Additionally, metadata
                                    will consist of data that you chose to
                                    provide with your User Content, e.g. any hashtags used to mark keywords to the video
                                    and captions.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Tracking Technologies and Cookies:
                                </h3>

                                <p>
                                    We use Cookies and similar tracking technologies to track the activity on Our
                                    Service and store certain information.
                                    Tracking technologies used are beacons, tags, and scripts to collect and track
                                    information and to improve and analyze
                                    Our Service.
                                </p>
                                <p>
                                    You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is
                                    being sent. However, if You do not
                                    accept Cookies, You may not be able to use some parts of our Service.
                                </p>

                                <p>
                                    Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on your
                                    personal computer or mobile device
                                    when You go offline, while Session Cookies are deleted as soon as You close your web
                                    browser.
                                </p>
                                <h4>
                                    We use both session and persistent Cookies for the purposes set out below:
                                </h4>

                                <li>
                                    <b>Necessary / Essential Cookies</b>
                                </li>

                                <p>
                                    <b>Type: Session Cookies</b>
                                </p>
                                <p>
                                    Administered by: <b>Us</b>
                                </p>

                                <p>
                                    <b>Purpose:</b> These Cookies are essential to provide You with services available
                                    through the Website and to enable You to use
                                    some of its features. They help to authenticate users and prevent fraudulent use of
                                    user accounts. Without these
                                    Cookies, the services that You have asked for cannot be provided, and We only use
                                    these Cookies to provide You with
                                    those services.
                                </p>

                                <li>
                                    <b>
                                        Cookies Policy / Notice Acceptance Cookies
                                    </b>
                                </li>
                                <p>
                                    <b>Type: Persistent Cookies</b>
                                </p>
                                <p>
                                    Administered by: <b>Us</b>
                                </p>

                                <p>
                                    <b>Purpose:</b> These Cookies identify if users have accepted the use of cookies on
                                    the Website.
                                </p>

                                <li>
                                    <b>Functionality Cookies</b>
                                </li>

                                <p>
                                    <b>
                                        Type: Persistent Cookies
                                    </b>
                                </p>

                                <p>
                                    Administered by: <b>Us</b>
                                </p>

                                <p>
                                    <b>Purpose:</b> These Cookies allow us to remember choices You make when You use the
                                    Website, such as remembering your login
                                    details or language preference. The purpose of these Cookies is to provide You with
                                    a more personal experience and to
                                    avoid You having to re-enter your preferences every time You use the Website.
                                </p>

                                <h2>
                                    Use of Your Personal Data
                                </h2>
                                <h4>
                                    Zimble may use Personal Data for the following purposes:
                                </h4>
                                <p>
                                    <li>
                                        <b>To provide and maintain our Service,</b> including to monitor the usage of
                                        our Service.
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b>To manage Your Account:</b> to manage Your registration as a user of the
                                        Service. The Personal Data You provide can give You
                                        access to different functionalities of the Service that are available to You as
                                        a registered user.
                                    </li>
                                </p>

                                <p>
                                    <li>
                                        <b>For the performance of a contract:</b> the development, compliance and
                                        undertaking of the purchase contract for the
                                        products, items or services You have purchased or of any other contract with Us
                                        through the Service.
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b>To contact You: </b>To contact You by email, telephone calls, SMS, or other
                                        equivalent forms of electronic communication,
                                        such as a mobile application's push notifications regarding updates or
                                        informative communications related to the
                                        functionalities, products or contracted services, including the security
                                        updates, when necessary or reasonable for their
                                        implementation.
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b>To provide You</b> with news, special offers and general information about
                                        other goods, services and events which we offer
                                        that are similar to those that you have already purchased or enquired about
                                        unless You have opted not to receive such
                                        information.
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b> To manage Your requests: </b>To attend and manage Your requests to Us.
                                    </li>
                                </p>

                                <p>
                                    <li>
                                        <b>To Protect our users: </b>to help us detect abuse, fraud, and illegal
                                        activity on the Platform
                                    </li>
                                </p>

                                <h4>
                                    We may share your personal information in the following situations:
                                </h4>

                                <p>
                                    <li>
                                        <b>With Service Providers: </b>We may share Your personal information with
                                        Service Providers to monitor and analyze the use of
                                        our Service, to contact You.
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b>For Business transfers:</b> We may share or transfer Your personal
                                        information in connection with, or during negotiations
                                        of, any merger, sale of Company assets, financing, or acquisition of all or a
                                        portion of our business to another
                                        company.
                                    </li>
                                </p>
                                <p>
                                    <li>
                                        <b>With Affiliates: </b>We may share Your information with Our affiliates, in
                                        which case we will require those affiliates to
                                        honor this Privacy Policy. Affiliates include Our parent company and any other
                                        subsidiaries, joint venture partners or
                                        other companies that We control or that are under common control with Us.
                                    </li>
                                </p>

                                <p>
                                    <li>
                                        <b>With Business partners: </b>We may share Your information with Our business
                                        partners to offer You certain products, services
                                        or promotions.
                                    </li>
                                </p>

                                <p>
                                    <li>
                                        <b>With other users:</b> when You share personal information or otherwise
                                        interact in the public areas with other users, such
                                        information may be viewed by all users and may be publicly distributed outside.
                                        If You interact with other users or
                                        register through a Third-Party Social Media Service, Your contacts on the
                                        Third-Party Social Media Service may see Your
                                        name, profile, and description of Your activity. Similarly, other users will be
                                        able to view descriptions of
                                        Your activity, communicate with You and view Your profile.
                                    </li>
                                </p>
                                <h3 className="the-zimble-policies-header">
                                    Retention of Your Personal Data
                                </h3>
                                <p>
                                    The Company will retain Your Personal Data only for as long as is necessary for the
                                    purposes set out in this Privacy
                                    Policy. We will retain and use Your Personal Data to the extent necessary to comply
                                    with our legal obligations (for
                                    example, if we are required to retain your data to comply with applicable laws),
                                    resolve disputes, and enforce our legal
                                    agreements and policies.
                                </p>
                                <p>
                                    The Company will also retain Usage Data for internal analysis purposes. Usage Data
                                    is generally retained for a shorter
                                    period of time, except when this data is used to strengthen the security or to
                                    improve the functionality of Our Service,
                                    or We are legally obligated to retain this data for longer time periods.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Transfer of Your Personal Data
                                </h3>

                                <p>
                                    Your information, including Personal Data, is processed at the Company's operating
                                    offices and in any other places where
                                    the parties involved in the processing are located. It means that this information
                                    may be transferred to — and
                                    maintained on — computers located outside of Your state, province, country or other
                                    governmental jurisdiction where the
                                    data protection laws may differ than those from Your jurisdiction.
                                </p>
                                <p>
                                    Your consent to this Privacy Policy followed by Your submission of such information
                                    represents Your agreement to that
                                    transfer.
                                </p>
                                <p>
                                    The Company will take all steps reasonably necessary to ensure that Your data is
                                    treated securely and in accordance with
                                    this Privacy Policy and no transfer of Your Personal Data will take place to an
                                    organization or a country unless there
                                    are adequate controls in place including the security of Your data and other
                                    personal information.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Disclosure of Your Personal Data
                                </h3>

                                <h4>
                                    Business Transactions
                                </h4>
                                <p>
                                    If the Company is involved in a merger, acquisition or asset sale, Your Personal
                                    Data may be transferred. We will
                                    provide notice before Your Personal Data is transferred and becomes subject to a
                                    different Privacy Policy.
                                </p>

                                <h4>
                                    Law enforcement
                                </h4>

                                <p>
                                    Under certain circumstances, the Company may be required to disclose Your Personal
                                    Data if required to do so by law or
                                    in response to valid requests by public authorities (e.g. a court or a government
                                    agency).
                                </p>

                                <h4>
                                    Other legal requirements
                                </h4>
                                <p>
                                    The Company may disclose Your Personal Data in the good faith belief that such
                                    action is necessary to:
                                </p>
                                <li>
                                    Comply with a legal obligation
                                </li>
                                <li>
                                    Protect and defend the rights or property of the Company
                                </li>

                                <li>
                                    Prevent or investigate possible wrongdoing in connection with the Service
                                </li>
                                <li>
                                    Protect the personal safety of Users of the Service or the public
                                </li>

                                <li>
                                    Protect against legal liability
                                </li>
                                <h3 className="the-zimble-policies-header">
                                    Security of Your Personal Data
                                </h3>

                                <p>
                                    The security of Your Personal Data is important to Us, but remember that no method
                                    of transmission over the Internet, or
                                    method of electronic storage is 100% simport AppFooter from '../footer/footer';
                                    ecure. While We strive to use commercially acceptable means to protect Your
                                    Personal Data, We cannot guarantee its absolute security.
                                </p>

                                <h2>
                                    Detailed Information on the Processing of Your Personal Data
                                </h2>
                                <p>
                                    Service Providers have access to Your Personal Data only to perform their tasks on
                                    Our behalf and are obligated not to
                                    disclose or use it for any other purpose. Zimble will not sell user personal
                                    information.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Usage, Performance and Miscellaneous
                                </h3>

                                <p>
                                    We may use third-party Service Providers to provide better improvement of our
                                    Service.
                                </p>

                                <p>
                                    We share the categories of personal information listed above with service providers
                                    and business partners to help us
                                    perform business operations and for business purposes, including research, payment
                                    processing and transaction
                                    fulfillment, database maintenance, administering contests and special offers,
                                    technology services, deliveries, email
                                    deployment, advertising, analytics, measurement, data storage and hosting, disaster
                                    recovery, search engine
                                    optimization, marketing, and data processing.
                                </p>

                                <p>
                                    We may share your information in connection with a substantial corporate
                                    transaction, such as the sale of a website, a
                                    merger, consolidation, asset sale, or in the unlikely event of bankruptcy.
                                </p>

                                <p>
                                    We may disclose your information to respond to subpoenas, court orders, legal
                                    process, law enforcement requests, legal
                                    claims, or government inquiries, and to protect and defend the rights, interests,
                                    safety, and security of Zimble the
                                    Platform, our affiliates, users, or the public. We may also share your information
                                    to enforce any terms applicable to
                                    the Platform, to exercise or defend any legal claims, and comply with any applicable
                                    law.
                                </p>

                                <p>
                                    We may share information for other purposes pursuant to your consent or with your
                                    further direction.
                                </p>

                                <p>
                                    If you choose to engage in public activities on the Platform, you should be aware
                                    that any information you share may be
                                    read, collected, or used by other users. You should use caution in disclosing
                                    personal information while engaging. We
                                    are not responsible for the information you choose to submit.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    User Rights
                                </h3>
                                <p>
                                    You may submit a request to access or delete the information we have collected about
                                    you by sending your request to us
                                    at the email or physical address provided in the Contact section at the bottom of
                                    this policy. We will respond to your
                                    request consistent with applicable law and subject to proper verification. And we do
                                    not discriminate based on the
                                    exercise of any privacy rights that you might have.
                                </p>
                                <p>
                                    You may be able to refuse or disable Cookies by adjusting your browser settings.
                                    Because each browser is different,
                                    please consult the instructions provided by your browser. Please note that you may
                                    need to take additional steps to
                                    refuse or disable certain types of Cookies. Your choice to disable cookies is
                                    specific to the particular browser or
                                    device that you are using when you disable cookies, so you may need to separately
                                    disable cookies for each type of
                                    browser or device. If you choose to refuse, disable, or delete Cookies, some of the
                                    functionality of the Platform may no
                                    longer be available to you. Without this information, we are not able to provide you
                                    with all the requested services,
                                    and any differences in services are related to your information.
                                </p>

                                <p>
                                    Your mobile device may include a feature that allows you to opt out of some types of
                                    targeted advertising ("Limit Ad
                                    Tracking" on iOS and "Opt out of Interest-Based Ads" on Android).
                                </p>

                                <p>
                                    You can opt out of marketing or advertising emails by utilizing the “unsubscribe”
                                    link or mechanism noted in marketing
                                    or advertising emails.
                                </p>

                                <p>
                                    You can switch off GPS location information functionality on your mobile device if
                                    you do not wish to share GPS
                                    information.
                                </p>
                                <p>
                                    If you have registered for an account you may access, review, and update certain
                                    personal information that you have
                                    provided to us by logging into your account and using available features and
                                    functionalities.
                                </p>

                                <p>
                                    Some browsers transmit "do-not-track" signals to websites. Because of differences in
                                    how browsers incorporate and
                                    activate this feature, it is not always clear whether users intend for these signals
                                    to be transmitted, or whether they
                                    even are aware of them. We currently do not take action in response to these
                                    signals.
                                </p>

                                <p>
                                    We use reasonable measures to help protect information from loss, theft, misuse and
                                    unauthorized access, disclosure,
                                    alteration, and destruction. You should understand that no data storage system or
                                    transmission of data over the Internet
                                    or any other public network can be guaranteed to be 100 percent secure. Please note
                                    that information collected by third
                                    parties may not have the same security protections as information you submit to us,
                                    and we are not responsible for
                                    protecting the security of such information.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Children's Privacy
                                </h3>

                                <p>
                                    Our Service does not address anyone under the age of 13. We do not knowingly collect
                                    personally identifiable information
                                    from anyone under the age of 13. If You are a parent or guardian and You are aware
                                    that Your child has provided Us with
                                    Personal Data, please contact Us. If We become aware that We have collected Personal
                                    Data from anyone under the age of
                                    13 without verification of parental consent, We take steps to remove that
                                    information from Our servers.
                                </p>

                                <p>
                                    If We need to rely on consent as a legal basis for processing Your information and
                                    Your country requires consent from a
                                    parent, We may require Your parent's consent before We collect and use that
                                    information.
                                </p>
                                <h3 className="the-zimble-policies-header">
                                    Links to Other Websites
                                </h3>
                                <p>
                                    Our Service may contain links to other websites that are not operated by Us. If You
                                    click on a third party link, You
                                    will be directed to that third party's site. We strongly advise You to review the
                                    Privacy Policy of every site You
                                    visit.
                                </p>
                                <p>
                                    We have no control over and assume no responsibility for the content, privacy
                                    policies or practices of any third party
                                    sites or services.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Changes to this Privacy Policy
                                </h3>
                                <p>
                                    We may update our Privacy Policy from time to time. We will notify You of any
                                    changes by posting the new Privacy Policy
                                    on this page.
                                </p>

                                <p>
                                    We will let You know via email and/or a prominent notice on Our Service, prior to
                                    the change becoming effective and
                                    update the "Last updated" date at the top of this Privacy Policy.
                                </p>

                                <p>
                                    You are advised to review this Privacy Policy periodically for any changes. Changes
                                    to this Privacy Policy are effective
                                    when they are posted on this page.
                                </p>

                                <h3 className="the-zimble-policies-header">
                                    Contact Us
                                </h3>

                                <p>
                                    If you have any questions about this Privacy Policy, You can contact
                                    us: <b>info@thezimble.com</b>
                                </p>
                            </article>

                        </div>

                    </section>

                </div>


                <div className='gradient-half-primary-v1'>
                    <AppFooter/>
                </div>
            </React.Fragment>
        )

    }

}

export default Privacy